import { render } from "./UserViewReset.vue?vue&type=template&id=d20f766a&scoped=true&ts=true"
import script from "./UserViewReset.vue?vue&type=script&lang=ts"
export * from "./UserViewReset.vue?vue&type=script&lang=ts"

import "./UserViewReset.vue?vue&type=style&index=0&id=d20f766a&lang=scss&scoped=true"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d20f766a"]])

export default __exports__